<template>
  <div class="bg-neutral-100 dark:bg-neutral-800 pb-20 mb-20 rounded-lg">
    <div class="text-right">
      <button
        class="cursor-pointer border-0 bg-transparent p-4 text-xl hover:text-neutral-700"
        @click="$emit('onClose')"
      >
        <pe-icon>close</pe-icon>
      </button>
    </div>

    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  }
})
</script>

<style lang="scss" scoped></style>
